module.exports = __webpack_public_path__ + "assets/images/premium-features/usersVisibility-42b1b3.svg";